import React, { FC } from 'react';
import type { LinkProps } from '@chakra-ui/react';
import { useColorMode, Link } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';

interface NavigationLinkProps extends LinkProps {
  href: string;
  text: string;
  isRightLink?: boolean;
}

export const NavigationLink: FC<NavigationLinkProps> = ({
  href,
  isRightLink = false,
  text = 'Back',
  ...rest
}) => {
  const modeProps = useColorMode();
  const blue = mode('blue', 'brand.yellow')(modeProps);
  const getBorderColor = () => {
    if (modeProps.colorMode === 'dark') {
      return 'brand.yellow';
    }
  };
  return (
    <Link
      position="relative"
      fontWeight="bold"
      color={blue}
      border={mode('none', '1px solid')(modeProps)}
      borderColor={getBorderColor()}
      href={href}
      background="none"
      {...rest}
    >
      {isRightLink ? (
        <>
          {text} <ChevronRightIcon w={4} h={4} />
        </>
      ) : (
        <>
          <ChevronLeftIcon w={4} h={4} /> {text}
        </>
      )}
    </Link>
  );
};
